module.exports = __webpack_public_path__ + "img/slide_img.03b2a4bd.png";